import { render } from "./WhyWebBased.vue?vue&type=template&id=43e549fe"
import script from "./WhyWebBased.vue?vue&type=script&lang=js"
export * from "./WhyWebBased.vue?vue&type=script&lang=js"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__